import React from "react";
import isMobile from "is-mobile";
import { Input } from "components/Input";
import { Table } from "../../style";
import { Body, Header } from "components/Table/style";

const Steps = (props) => {
  return (
    <Table>
      <Header>
        <tr>
          <th>
            <span></span>
          </th>
          {isMobile() ? (
            <th>
              <span>Fase</span>
            </th>
          ) : (
            <>
              <th>
                <span>Pré</span>
              </th>
              <th>
                <span>Inicial</span>
              </th>
              <th>
                <span>Crescimento</span>
              </th>
              <th>
                <span>Desenvolvimento</span>
              </th>
            </>
          )}
        </tr>
      </Header>
      <Body>
        <tr>
          <td>
            <span>
              <b>Produção:</b>
            </span>
          </td>
          {isMobile() ? (
            <td>
              <Input
                type="input"
                inputType="number"
                value={props.megg.premixSteps.pre.feedProductionYear}
                label="Pré"
              />
              <Input
                type="input"
                inputType="number"
                value={props.megg.premixSteps.initial.feedProductionYear}
                label="Inicial"
              />
              <Input
                type="input"
                inputType="number"
                value={props.megg.premixSteps.growth.feedProductionYear}
                label="Crescimento"
              />
              <Input
                type="input"
                inputType="number"
                value={props.megg.premixSteps.development.feedProductionYear}
                label="Desenvolvimento"
              />
            </td>
          ) : (
            <>
              <td>
                <Input
                  type="inputOnly"
                  inputType="number"
                  value={props.megg.premixSteps.pre.feedProductionYear}
                  placeholder="Pré"
                />
              </td>
              <td>
                <Input
                  type="inputOnly"
                  inputType="number"
                  value={props.megg.premixSteps.initial.feedProductionYear}
                  placeholder="Inicial"
                />
              </td>
              <td>
                <Input
                  type="inputOnly"
                  inputType="number"
                  value={props.megg.premixSteps.growth.feedProductionYear}
                  placeholder="Crescimento"
                />
              </td>
              <td>
                <Input
                  type="inputOnly"
                  inputType="number"
                  value={props.megg.premixSteps.development.feedProductionYear}
                  placeholder="Desenvolvimento"
                />
              </td>
            </>
          )}
        </tr>
        <tr>
          <td>
            <span>
              <b>Forma Física:</b>
            </span>
          </td>
          {isMobile() ? (
            <td>
              <Input
                type="input"
                params="premixSteps.pre.physicalForm"
                item={props.megg}
                setItem={props.setMegg}
                placeholder="Pré"
                label="Pré"
              />

              <Input
                type="input"
                params="premixSteps.initial.physicalForm"
                item={props.megg}
                setItem={props.setMegg}
                placeholder="Inicial"
                label="Inicial"
              />

              <Input
                type="input"
                params="premixSteps.growth.physicalForm"
                item={props.megg}
                setItem={props.setMegg}
                placeholder="Crescimento"
                label="Crescimento"
              />

              <Input
                type="input"
                params="premixSteps.development.physicalForm"
                item={props.megg}
                setItem={props.setMegg}
                placeholder="Desenvolvimento"
                label="Desenvolvimento"
              />
            </td>
          ) : (
            <>
              <td>
                <Input
                  type="inputOnly"
                  params="premixSteps.pre.physicalForm"
                  item={props.megg}
                  setItem={props.setMegg}
                  placeholder="Pré"
                />
              </td>
              <td>
                <Input
                  type="inputOnly"
                  params="premixSteps.initial.physicalForm"
                  item={props.megg}
                  setItem={props.setMegg}
                  placeholder="Inicial"
                />
              </td>
              <td>
                <Input
                  type="inputOnly"
                  params="premixSteps.growth.physicalForm"
                  item={props.megg}
                  setItem={props.setMegg}
                  placeholder="Crescimento"
                />
              </td>
              <td>
                <Input
                  type="inputOnly"
                  params="premixSteps.development.physicalForm"
                  item={props.megg}
                  setItem={props.setMegg}
                  placeholder="Desenvolvimento"
                />
              </td>
            </>
          )}
        </tr>
        <tr>
          <td>
            <span>
              <b>Fornecedor:</b>
            </span>
          </td>
          {isMobile() ? (
            <td>
              <Input
                type="input"
                params="premixSteps.pre.provider"
                item={props.megg}
                setItem={props.setMegg}
                label="Pré"
              />

              <Input
                type="input"
                params="premixSteps.initial.provider"
                item={props.megg}
                setItem={props.setMegg}
                label="Inicial"
              />

              <Input
                type="input"
                params="premixSteps.growth.provider"
                item={props.megg}
                setItem={props.setMegg}
                label="Crescimento"
              />

              <Input
                type="input"
                params="premixSteps.development.provider"
                item={props.megg}
                setItem={props.setMegg}
                label="Desenvolvimento"
              />
            </td>
          ) : (
            <>
              <td>
                <Input
                  type="inputOnly"
                  params="premixSteps.pre.provider"
                  item={props.megg}
                  setItem={props.setMegg}
                  placeholder="Pré"
                />
              </td>
              <td>
                <Input
                  type="inputOnly"
                  params="premixSteps.initial.provider"
                  item={props.megg}
                  setItem={props.setMegg}
                  placeholder="Inicial"
                />
              </td>
              <td>
                <Input
                  type="inputOnly"
                  params="premixSteps.growth.provider"
                  item={props.megg}
                  setItem={props.setMegg}
                  placeholder="Crescimento"
                />
              </td>
              <td>
                <Input
                  type="inputOnly"
                  params="premixSteps.development.provider"
                  item={props.megg}
                  setItem={props.setMegg}
                  placeholder="Desenvolvimento"
                />
              </td>
            </>
          )}
        </tr>
        <tr>
          <td>
            <span>
              <b>Descrição Comum:</b>
            </span>
          </td>
          {isMobile() ? (
            <td>
              <Input
                type="input"
                params="premixSteps.pre.commonDescription"
                item={props.megg}
                setItem={props.setMegg}
                placeholder="Pré"
                label="Pré"
              />

              <Input
                type="input"
                params="premixSteps.initial.commonDescription"
                item={props.megg}
                setItem={props.setMegg}
                placeholder="Inicial"
                label="Inicial"
              />

              <Input
                type="input"
                params="premixSteps.growth.commonDescription"
                item={props.megg}
                setItem={props.setMegg}
                placeholder="Crescimento"
                label="Crescimento"
              />

              <Input
                type="input"
                params="premixSteps.development.commonDescription"
                item={props.megg}
                setItem={props.setMegg}
                placeholder="Desenvolvimento"
                label="Desenvolvimento"
              />
            </td>
          ) : (
            <>
              <td>
                <Input
                  type="inputOnly"
                  params="premixSteps.pre.commonDescription"
                  item={props.megg}
                  setItem={props.setMegg}
                  placeholder="Pré"
                />
              </td>
              <td>
                <Input
                  type="inputOnly"
                  params="premixSteps.initial.commonDescription"
                  item={props.megg}
                  setItem={props.setMegg}
                  placeholder="Inicial"
                />
              </td>
              <td>
                <Input
                  type="inputOnly"
                  params="premixSteps.growth.commonDescription"
                  item={props.megg}
                  setItem={props.setMegg}
                  placeholder="Crescimento"
                />
              </td>
              <td>
                <Input
                  type="inputOnly"
                  params="premixSteps.development.commonDescription"
                  item={props.megg}
                  setItem={props.setMegg}
                  placeholder="Desenvolvimento"
                />
              </td>
            </>
          )}
        </tr>
        <tr>
          <td>
            <span>
              <b>Classe PX:</b>
            </span>
          </td>
          {isMobile() ? (
            <td>
              <Input
                type="input"
                params="premixSteps.pre.pxClass"
                item={props.megg}
                setItem={props.setMegg}
                label="Pré"
              />

              <Input
                type="input"
                params="premixSteps.initial.pxClass"
                item={props.megg}
                setItem={props.setMegg}
                label="Inicial"
              />

              <Input
                type="input"
                params="premixSteps.growth.pxClass"
                item={props.megg}
                setItem={props.setMegg}
                label="Crescimento"
              />

              <Input
                type="input"
                params="premixSteps.development.pxClass"
                item={props.megg}
                setItem={props.setMegg}
                label="Desenvolvimento"
              />
            </td>
          ) : (
            <>
              <td>
                <Input
                  type="inputOnly"
                  params="premixSteps.pre.pxClass"
                  item={props.megg}
                  setItem={props.setMegg}
                  placeholder="Pré"
                />
              </td>
              <td>
                <Input
                  type="inputOnly"
                  params="premixSteps.initial.pxClass"
                  item={props.megg}
                  setItem={props.setMegg}
                  placeholder="Inicial"
                />
              </td>
              <td>
                <Input
                  type="inputOnly"
                  params="premixSteps.growth.pxClass"
                  item={props.megg}
                  setItem={props.setMegg}
                  placeholder="Crescimento"
                />
              </td>
              <td>
                <Input
                  type="inputOnly"
                  params="premixSteps.development.pxClass"
                  item={props.megg}
                  setItem={props.setMegg}
                  placeholder="Desenvolvimento"
                />
              </td>
            </>
          )}
        </tr>
      </Body>
    </Table>
  );
};

export default Steps;
